import React from "react";
import { Container, Form, Row, Col } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import AppButton from "../../Components/MerchantButton";
import "./UnifiedFormStyles.css";

export default function TerminalConcerns({ navigation }) {
  const handleBack = (e) => {
    navigation.previous();
  };
  const handleNext = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    if (navigation && navigation.go) navigation.go('zero-to-low-merchant');
  };

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">TERMINAL & SQR CONCERNS</h4>
              <p className="form-desc">Check all that apply and provide details where needed</p>
            </div>
            <div className="form-main">
              <div className="form-main-content">
                <Form>
                  {/* SIM Card Issue */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">SIM Card Issue <span className="form-required">*</span></Form.Label>
                    <div>
                      {[
                        "Weak signal indicator",
                        "No signal indicator",
                        "3G and below signal indicator",
                        'Terminal showing "Online Declined"',
                        'Terminal showing "Pending Reversal"',
                        "Other signal issue",
                        "Other connectivity issue",
                        "Missing SIM card",
                        "Other SIM card concerns",
                        "No concerns"
                      ].map((opt) => (
                        <Form.Check key={opt} type="checkbox" label={opt} name="simCard" value={opt} className="form-checkbox-option" />
                      ))}
                    </div>
                    <Form.Control name="simCard_other_details" type="text" placeholder="Other SIM card issue/details" className="form-input mt-2" />
                  </Form.Group>

                  {/* Charger Issue */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">Charger Issue <span className="form-required">*</span></Form.Label>
                    <div>
                      {[
                        "Charger not working",
                        "Charger has physical damage",
                        "Missing charger/cable",
                        "Battery level not increasing while charging",
                        "No concerns"
                      ].map((opt) => (
                        <Form.Check key={opt} type="checkbox" label={opt} name="charger" value={opt} className="form-checkbox-option" />
                      ))}
                    </div>
                    <Form.Control name="charger_other_details" type="text" placeholder="Other charger issue/details" className="form-input mt-2" />
                  </Form.Group>

                  {/* Battery Issue */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">Battery Issue <span className="form-required">*</span></Form.Label>
                    <div>
                      {[
                        "Fully charged but battery level drops",
                        "Bloated battery",
                        "Yellow battery indicator",
                        "Other battery related concerns",
                        "No concerns"
                      ].map((opt) => (
                        <Form.Check key={opt} type="checkbox" label={opt} name="battery" value={opt} className="form-checkbox-option" />
                      ))}
                    </div>
                    <Form.Control name="battery_other_details" type="text" placeholder="Other battery issue/details" className="form-input mt-2" />
                  </Form.Group>

                  {/* LCD Issue */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">LCD Issue <span className="form-required">*</span></Form.Label>
                    <div>
                      {[
                        "Ghost touch",
                        "Unresponsive screen",
                        "Hanging",
                        "Cracked or broken screen",
                        "Other LCD concerns",
                        "No concerns"
                      ].map((opt) => (
                        <Form.Check key={opt} type="checkbox" label={opt} name="lcd" value={opt} className="form-checkbox-option" />
                      ))}
                    </div>
                    <Form.Control name="lcd_other_details" type="text" placeholder="Other LCD issue/details" className="form-input mt-2" />
                  </Form.Group>

                  {/* Terminal Issue */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">Terminal Issue <span className="form-required">*</span></Form.Label>
                    <div>
                      {[
                        "Missing or defective printer cover",
                        "Missing or defective back cover",
                        "Damaged charging port",
                        "PED tampered (A920)",
                        "Stuck blue light (A920)",
                        "PAX A920 signal armor"
                      ].map((opt) => (
                        <Form.Check key={opt} type="checkbox" label={opt} name="terminal" value={opt} className="form-checkbox-option" />
                      ))}
                    </div>
                    <Form.Control name="terminal_other_details" as="textarea" rows={3} placeholder="Other terminal issue/details" className="form-input mt-2" />
                  </Form.Group>

                  {/* Cradle Issue */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">Cradle Issue</Form.Label>
                    <div>
                      {["Defective cradle"].map((opt) => (
                        <Form.Check key={opt} type="checkbox" label={opt} name="cradle" value={opt} className="form-checkbox-option" />
                      ))}
                    </div>
                    <Form.Control name="cradle_other_details" type="text" placeholder="Other cradle issue" className="form-input mt-2" />
                  </Form.Group>

                  {/* Software/Application Issue */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">Software/Application Issue <span className="form-required">*</span></Form.Label>
                    <div>
                      {[
                        "Firmware download mode (A920)",
                        "RKI 1401 (A920)",
                        "Lost PIN",
                        "Needs password reset",
                        "Failed card transactions",
                        "Failed QR transactions",
                        "Other software/application issues",
                        "No concerns"
                      ].map((opt) => (
                        <Form.Check key={opt} type="checkbox" label={opt} name="software" value={opt} className="form-checkbox-option" />
                      ))}
                    </div>
                    <Form.Control name="software_other_details" type="text" placeholder="Other software/application issue/details" className="form-input mt-2" />
                  </Form.Group>

                  {/* SQR Issue */}
                  <Form.Group className="mb-4">
                    <Form.Label className="form-label">SQR Issue <span className="form-required">*</span></Form.Label>
                    <div>
                      {[
                        "SQR replacement",
                        "SQR phone defective",
                        "SQR SIM card defective/missing",
                        "SQR phone battery defective",
                        "SQR phone charger defective/missing",
                        "Other SQR concerns",
                        "No concerns"
                      ].map((opt) => (
                        <Form.Check key={opt} type="checkbox" label={opt} name="sqr" value={opt} className="form-checkbox-option" />
                      ))}
                    </div>
                    <Form.Control name="sqr_other_details" type="text" placeholder="Other SQR issue/details" className="form-input mt-2" />
                  </Form.Group>

                  <div className="form-nav-btns">
                    <AppButton type="button" onClick={handleBack} variant="back" className="form-btn variant-secondary">
                      ← Back 
                    </AppButton>
                    <AppButton type="button" onClick={handleNext} variant="next" className="form-btn variant-primary">
                       Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}
